import { render } from "./ModalData.vue?vue&type=template&id=679d7f52&scoped=true&ts=true"
import script from "./ModalData.vue?vue&type=script&lang=ts"
export * from "./ModalData.vue?vue&type=script&lang=ts"

import "./ModalData.vue?vue&type=style&index=0&id=679d7f52&scoped=true&lang=css"
import "./ModalData.vue?vue&type=style&index=1&id=679d7f52&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679d7f52"]])

export default __exports__